import { useState, useEffect } from 'react';
import { useCompany } from '../components/Layout';
import api from '../utils/api';

export default function SettingsPage() {
  const { activeCompany, setActiveCompany } = useCompany();
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [msgType, setMsgType] = useState('success');

  useEffect(() => {
    if (activeCompany) setForm({ ...activeCompany });
  }, [activeCompany]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    setSaving(true); setMsg('');
    try {
      const { data } = await api.put(`/companies/${activeCompany.id}`, form);
      setActiveCompany(data);
      setMsg('Settings saved successfully!'); setMsgType('success');
    } catch (e) {
      setMsg(e.response?.data?.error || 'Save failed'); setMsgType('error');
    } finally {
      setSaving(false);
      setTimeout(() => setMsg(''), 4000);
    }
  };

  if (!form.id) return <div className="loading">Loading...</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h2>Settings</h2>
          <p>Configure {activeCompany?.name} details</p>
        </div>
      </div>

      {msg && (
        <div style={{ background: msgType === 'success' ? '#dcfce7' : '#fee2e2', color: msgType === 'success' ? '#16a34a' : '#dc2626', padding: '12px 16px', borderRadius: 8, marginBottom: 18, fontSize: 14 }}>
          {msg}
        </div>
      )}

      <div className="card">
        <h4 style={{ marginBottom: 16, fontSize: 15, fontWeight: 600, borderBottom: '1px solid #f0f0f0', paddingBottom: 12 }}>Company Information</h4>
        <div className="form-grid form-grid-2" style={{ marginBottom: 16 }}>
          <div className="form-group">
            <label>Company Name</label>
            <input className="form-control" value={form.name || ''} onChange={e => set('name', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Invoice Prefix</label>
            <input className="form-control" value={form.invoice_prefix || ''} onChange={e => set('invoice_prefix', e.target.value)} placeholder="e.g. SD or EH" style={{ fontFamily: 'monospace' }} />
          </div>
        </div>
        <div className="form-group" style={{ marginBottom: 16 }}>
          <label>Address</label>
          <textarea className="form-control" rows={2} value={form.address || ''} onChange={e => set('address', e.target.value)} />
        </div>
        <div className="form-grid form-grid-3" style={{ marginBottom: 16 }}>
          <div className="form-group">
            <label>City</label>
            <input className="form-control" value={form.city || ''} onChange={e => set('city', e.target.value)} />
          </div>
          <div className="form-group">
            <label>State</label>
            <input className="form-control" value={form.state || ''} onChange={e => set('state', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Pincode</label>
            <input className="form-control" value={form.pincode || ''} onChange={e => set('pincode', e.target.value)} />
          </div>
        </div>
        <div className="form-grid form-grid-2" style={{ marginBottom: 16 }}>
          <div className="form-group">
            <label>Email</label>
            <input className="form-control" type="email" value={form.email || ''} onChange={e => set('email', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input className="form-control" value={form.phone || ''} onChange={e => set('phone', e.target.value)} />
          </div>
        </div>
        <div className="form-group" style={{ marginBottom: 16 }}>
          <label>GSTIN</label>
          <input className="form-control" value={form.gstin || ''} onChange={e => set('gstin', e.target.value)} style={{ fontFamily: 'monospace' }} placeholder="e.g. 08ACUFS9062L1Z3" />
        </div>
        <div className="form-group">
          <label>Logo URL <span style={{ color: '#aaa', fontWeight: 400 }}>(hosted image URL — leave blank to use text)</span></label>
          <input className="form-control" value={form.logo_url || ''} onChange={e => set('logo_url', e.target.value)} placeholder="https://yoursite.com/logo.png" />
          {form.logo_url && <img src={form.logo_url} alt="logo preview" style={{ marginTop: 8, maxHeight: 60, borderRadius: 4 }} />}
        </div>
      </div>

      <div className="card">
        <h4 style={{ marginBottom: 16, fontSize: 15, fontWeight: 600, borderBottom: '1px solid #f0f0f0', paddingBottom: 12 }}>Bank Details <span style={{ fontSize: 12, color: '#aaa', fontWeight: 400 }}>(shown on all invoices)</span></h4>
        <div className="form-grid form-grid-2" style={{ marginBottom: 16 }}>
          <div className="form-group">
            <label>Bank Name</label>
            <input className="form-control" value={form.bank_name || ''} onChange={e => set('bank_name', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Account Name</label>
            <input className="form-control" value={form.account_name || ''} onChange={e => set('account_name', e.target.value)} />
          </div>
        </div>
        <div className="form-grid form-grid-3">
          <div className="form-group">
            <label>Account Number</label>
            <input className="form-control" value={form.account_number || ''} onChange={e => set('account_number', e.target.value)} style={{ fontFamily: 'monospace' }} />
          </div>
          <div className="form-group">
            <label>IFSC Code</label>
            <input className="form-control" value={form.ifsc || ''} onChange={e => set('ifsc', e.target.value)} style={{ fontFamily: 'monospace' }} />
          </div>
          <div className="form-group">
            <label>Swift Code <span style={{ color: '#aaa', fontWeight: 400 }}>(for USD)</span></label>
            <input className="form-control" value={form.swift || ''} onChange={e => set('swift', e.target.value)} style={{ fontFamily: 'monospace' }} />
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 32 }}>
        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save Settings'}</button>
      </div>
    </div>
  );
}
